// Sources send extensions with a dot (".xlsx") and some without ("csv"); the picker needs the dot.
export function normalizeExtensions(extensions: string[] = []): string[] {
  return extensions
    .map((ext) => ext.trim().replace(/^\./, "").toLowerCase())
    .filter(Boolean)
    .map((ext) => `.${ext}`);
}

// The server reads at most 50 MB of a mapped file's columns.
export const MAX_MAPPED_BYTES = 50 * 1024 * 1024;
